const initialState = {
  customers: {}
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'API:CUSTOMER_HOME:INFOMATION:SUCCESS':
      return updateCustomerInfomation(state, action)

    case 'API:CUSTOMER_HOME:CUSTOMER_PHOTOS:SUCCESS':
      return { ...state }

    case 'API:CUSTOMER_HOME:PERFECT_PRODUCTS:SUCCESS':
      return { ...state }

    case 'API:CUSTOMER_HOME:STYLE_ALBUM:SUCCESS':
      return { ...state }

    default:
      return state
  }
}

const updateCustomerInfomation = (state, action) => {
  const id = action.data.variables.id
  const customer = action.response.data.customer
  const customers = { ...state.customers }

  if (customer) {
    customers[id] = customer
  }

  return { ...state, customers }
}

export default reducer
